module.exports = {
  "country": "ES",
  "artist": "Bravo ",
  "song": "Lady Lady",
  "year": "1984",
  "place": "3",
  "spotify": "3K0rUw4z0khdNg4MiSIHB4"
};